import { Component, Input, OnInit } from "@angular/core";
import { MAP_DISTANCE_MILES } from "@app/core/constants/string-constants";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-distance",
  templateUrl: "./distance.component.html",
  styleUrls: ["./distance.component.scss"],
})
export class DistanceComponent implements OnInit {
  @Input() distanceInMiles = 50;
  @Input() globalDistanceMile = 50;
  miles = MAP_DISTANCE_MILES;
  distance: number;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit() {
    if (this.globalDistanceMile > 100) {
      this.miles[5] = {
        label: "100+",
        value: this.globalDistanceMile,
      };
    }
    this.distance = this.miles.findIndex(
      (mile) => mile.value === (this.distanceInMiles || 5)
    );
  }

  apply() {
    this.modalCtrl.dismiss(this.miles[this.distance].value);
  }
}
